class PDPProductOverviewCollapsable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.titleCta = this.querySelector("h3");
    this.collapsableContent = this.querySelector(
      ".overview-collapsable-content"
    );
    this.arrow = this.querySelector("h3 > span");

    this.titleCta.addEventListener("click", (event) => {
      const ctaElement = event.target.closest("h3");
      if (!ctaElement) return;
      this.toggleCollapsableContent();
    });
  }

  disconnectedCallback() {
    this.titleCta.removeEventListener(
      "click",
      () => {
        this.toggleCollapsableContent();
      },
      true
    );
  }

  toggleCollapsableContent() {
    const currentState = this.collapsableContent.dataset.collapseContent;
    this.collapsableContent.dataset.collapseContent =
      currentState === "false" ? true : false;

    this.arrow.dataset.rotateCollapsableItemIcon =
      currentState === "false" ? true : false;
  }
}

customElements.define(
  "pdp-product-overview-collapsable",
  PDPProductOverviewCollapsable
);
